import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavbarButton } from '../Layout/NavbarButton';
import DuotoneLightIcon from './DuotoneLightIcon';
import EmojiPicker from './EmojiPicker';
import ControlLabelRow from './ControlLabelRow';
import { iconButtonStyle } from '../../utils/styles';

/* Raccourcis d'insertion (emoji / variable texte / image) d'un éditeur de texte
   riche. Source unique de leur style — celui des box texte — pour que le panneau
   de droite et la barre flottante montrent les mêmes icônes quelle que soit la
   box sélectionnée (texte, titre, cellule de tableau...).
   `showLabels` : true (défaut) = panneau de droite, une ligne « bouton +
   libellé » par raccourci, empilées ; false = icônes seules côte à côte, pour la
   barre flottante. */
const InsertionControls = ({
  editorState,
  setEditorState,
  onAddAt,
  onAddImage,
  hasEmoji = true,
  hasImage = true,
  showLabels = true,
}) => {
  const { t } = useTranslation();

  const controls = [
    hasEmoji && {
      key: 'emoji',
      label: t('AJOUTER_UN_EMOJI'),
      control: (
        <EmojiPicker
          editorState={editorState}
          setEditorState={setEditorState}
          tooltipContent={t('AJOUTER_UN_EMOJI')}
        />
      ),
    },
    {
      key: 'at',
      label: t('AJOUTER_UNE_VARIABLE'),
      control: (
        <NavbarButton
          tooltipContent={t('AJOUTER_UNE_VARIABLE')}
          onClick={onAddAt}
          icon={<DuotoneLightIcon name='at' weight='solid' style={iconButtonStyle()} />}
        />
      ),
    },
    hasImage && {
      key: 'image',
      label: t('IMAGE_VARIABLE'),
      control: (
        <NavbarButton
          tooltipContent={t('IMAGE_VARIABLE')}
          onClick={onAddImage}
          icon={<DuotoneLightIcon name='image' weight='solid' style={iconButtonStyle()} />}
        />
      ),
    },
  ].filter(Boolean);

  if (!showLabels) {
    return <>{controls.map(({ key, control }) => <React.Fragment key={key}>{control}</React.Fragment>)}</>;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8, width: '100%' }}>
      {controls.map(({ key, control, label }) => (
        <ControlLabelRow key={key} control={control} label={label} />
      ))}
    </div>
  );
};

export default InsertionControls;
